import { Helmet } from 'react-helmet-async';
import { filter } from 'lodash';
import CircularProgress from '@mui/material/CircularProgress';
import { useState, useEffect, useCallback } from 'react';
import { useNavigate, Link, useLocation } from 'react-router-dom';
import { getToken, getUser } from '../../utils/common';

// @mui
import {
  Table,
  Popover,
  TableRow,
  MenuItem,
  TableBody,
  TableCell,
  Container,
  Typography,
  TableContainer,
  TablePagination,
  TextField,
  InputAdornment,
  Grid,
  Tabs,
  Tab,
  TableHead,
} from '@mui/material';
import { useTheme, styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { tableCellClasses } from '@mui/material/TableCell';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { Dropdown, Space, Empty } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import Iconify from '../../components/iconify';
import Scrollbar from '../../components/scrollbar';
import USERLIST from '../../_mock/alert';
import SearchIcon from '@mui/icons-material/Search';

function CustomTabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

export default function UserPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get('id');
  const [open, setOpen] = useState(null);
  const [page, setPage] = useState(0);
  const [total, settotal] = useState(1);
  const [order, setOrder] = useState('desc');
  const [selected, setSelected] = useState([]);
  const [orderBy, setOrderBy] = useState('name');
  const [filterName, setFilterName] = useState('');
  const [status, setstatus] = useState('status=open');
  const [data, setData] = useState([]);
  const [rowindex, setRow] = useState(1);
  const [data2, setData2] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [datachenges, setDatachanges] = useState([]);
  const [index, setindex] = useState(id || 0);
  const [ticketResult, setTicketResult] = useState();
  const navigate = useNavigate();
  const [rowNumber, setRownumber] = useState(1);
  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - USERLIST.length) : 0;
  const handleCloseMenu = () => {
    setOpen(null);
  };

  const theme = useTheme();
  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };
  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = USERLIST.map((n) => n.name);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    if (newPage == 1) {
      setRow(1 + rowsPerPage);
    } else {
      setRow(1 + rowsPerPage + rowsPerPage);
    }

    setPage(newPage);
    fetchInfo(
      window.REACT_APP_API_PURE + `alert?page=${newPage + 1}&` + status + '&limit=' + rowsPerPage + '&order=desc'
    );
  };

  const handleChangeRowsPerPage = (event) => {
    setRow(1);
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
    fetchInfo(
      window.REACT_APP_API_PURE +
        `alert?limit=${parseInt(event.target.value, 10)}&` +
        status +
        '&page=' +
        1 +
        '&order=desc'
    );
  };

  const handleClicker = () => {
    navigate('/dashboard/alertdetail', { replace: true });
  };

  const fetchInfo = useCallback(
    async (url) => {
      try {
        // console.log(getToken());
        return fetch(url, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
        })
          .then((res) => res.json())
          .then((d) => {
            // console.log(d);
            if (d.code === 401) {
              setData([]);
              settotal(0);
            } else {
              setData(d?.data);
              settotal(d?.pageMeta?.totalItems || 0);
              setRownumber(d?.pageMeta?.itemsPerPage * d?.pageMeta?.currentPage - (d?.pageMeta?.itemsPerPage - 1));
            }
          });
      } catch (error) {}
    },
    [data, setData, data?.data, status]
  );
  const fetchInfoTicket = useCallback(
    async (url, event, id) => {
      try {
        return fetch(url, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
        })
          .then((res) => res.json())
          .then((d) => {
            // setTicketResult(d);
            event.preventDefault();
            // if (d.ticket_status == 'Expired' || d.updated_by == getUser()) {
            //   fetchInfoTicketAssign(window.REACT_APP_API_PURE +'ticket/add-edit', id);
            // }

            // if (d.ticket_status === 'Valid' && d.updated_by != getUser()) {
            //   alert('Sory This alert already assign to other user');
            //   event.preventDefault();
            // }
          });
      } catch (error) {}
    },
    [ticketResult, setTicketResult]
  );

  const url2 = window.REACT_APP_API_PURE + 'reference/list?kode=F003';

  const fetchInfo2 = () => {
    return fetch(url2, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${getToken()}` },
    })
      .then((res) => res.json())
      .then((d) => {
        setData2(d);
      });
  };
  useEffect(() => {
    // fetchInfo(window.REACT_APP_API_PURE +'alert?' + status);
    fetchInfo2();
    handleChange('', id || 0);
  }, []);

  const handleChange = (event, newValue) => {
    setindex(newValue);
    setPage(0);
    if (newValue == 0 && order == 'desc') {
      setstatus('status=open');
      fetchInfo(
        window.REACT_APP_API_PURE + 'alert?' + 'status=open' + '&limit=' + rowsPerPage + '&page=' + 1 + '&order=desc'
      );
    } else if (newValue == 1 && order == 'desc') {
      setData([]);
      setstatus('status=inProgress');
      fetchInfo(
        window.REACT_APP_API_PURE +
          'alert?' +
          'status=inProgress' +
          '&limit=' +
          rowsPerPage +
          '&page=' +
          1 +
          '&order=desc'
      );
    } else if (newValue == 2 && order == 'desc') {
      setData([]);
      setstatus('status=pendingApproval');
      fetchInfo(
        window.REACT_APP_API_PURE +
          'alert?' +
          'status=pendingApproval' +
          '&limit=' +
          rowsPerPage +
          '&page=' +
          1 +
          '&order=desc'
      );
    } else if (newValue == 3 && order == 'desc') {
      setData([]);
      setstatus('status=pendingRollback');
      fetchInfo(
        window.REACT_APP_API_PURE +
          'alert?' +
          'status=pendingRollback' +
          '&limit=' +
          rowsPerPage +
          '&page=' +
          1 +
          '&order=desc'
      );
    } else if (newValue == 4 && order == 'desc') {
      setData([]);
      setstatus('status=closed');
      fetchInfo(
        window.REACT_APP_API_PURE + 'alert?' + 'status=closed' + '&limit=' + rowsPerPage + '&page=' + 1 + '&order=desc'
      );
    } else if (newValue == 0 && order == 'asc') {
      setData([]);
      setstatus('status=open');
      fetchInfo(
        window.REACT_APP_API_PURE + 'alert?' + 'status=open' + '&limit=' + rowsPerPage + '&page=' + 1 + '&order=asc'
      );
    } else if (newValue == 1 && order == 'asc') {
      setData([]);
      setstatus('status=inProgress');
      fetchInfo(
        window.REACT_APP_API_PURE +
          'alert?' +
          'status=inProgress' +
          '&limit=' +
          rowsPerPage +
          '&page=' +
          1 +
          '&order=asc'
      );
    } else if (newValue == 2 && order == 'asc') {
      setData([]);
      setstatus('status=pendingApproval');
      fetchInfo(
        window.REACT_APP_API_PURE +
          'alert?' +
          'status=pendingApproval' +
          '&limit=' +
          rowsPerPage +
          '&page=' +
          1 +
          '&order=asc'
      );
    } else if (newValue == 3 && order == 'asc') {
      setData([]);
      setstatus('status=pendingRollback');
      fetchInfo(
        window.REACT_APP_API_PURE +
          'alert?' +
          'status=pendingRollback' +
          '&limit=' +
          rowsPerPage +
          '&page=' +
          1 +
          '&order=asc'
      );
      // console.log('awdawdawd');
    } else if (newValue == 4 && order == 'asc') {
      setData([]);
      setstatus('status=closed');
      fetchInfo(
        window.REACT_APP_API_PURE + 'alert?' + 'status=closed' + '&limit=' + rowsPerPage + '&page=' + 1 + '&order=asc'
      );
    }
  };

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.primary.dark,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
  }));

  const { t } = useTranslation();

  function handleClickLang(lang) {
    i18next.changeLanguage(lang);
  }

  function SearchAndTittle() {
    return (
      <Grid container direction="row" justifyContent={'space-between'} style={{ marginBottom: 20 }}>
        <Grid item alignSelf={'center'}>
          <Typography variant="h5">Alert</Typography>
        </Grid>
        <Grid item>
          {' '}
          <TextField
            placeholder={t('Search.3')}
            variant="outlined"
            size="small"
            fullWidth
            onChange={(e) => {
              if (e.target.value === '') {
                fetchInfo(
                  window.REACT_APP_API_PURE +
                    `alert?` +
                    status +
                    '&limit=' +
                    rowsPerPage +
                    '&page=' +
                    (page + 1) +
                    '&order=desc'
                );
              } else
                fetchInfo(
                  window.REACT_APP_API_PURE + 'alert?recordId=' + e.target.value + '&' + status + '&order=desc'
                );
            }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </Grid>
    );
  }
  CustomTabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
  };

  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const onClick = ({ key }) => {
    index;
    if (key === '1') {
      setData([]);
      setOrder('asc');
      fetchInfo(
        window.REACT_APP_API_PURE + `alert?` + status + '&limit=' + rowsPerPage + '&page=' + (page + 1) + '&order=asc'
      );
    } else if (key === '2') {
      setData([]);
      setOrder('desc');
      fetchInfo(
        window.REACT_APP_API_PURE + `alert?` + status + '&limit=' + rowsPerPage + '&page=' + (page + 1) + '&order=desc'
      );
    }
  };

  const items = [
    {
      key: '1',
      label: <a>Latest</a>,
    },
    {
      key: '2',
      label: <a>Recent</a>,
    },
  ];

  const [showProgress, setShowProgress] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowProgress(false); // After 2 seconds, hide the CircularProgress
    }, 4000);

    return () => clearTimeout(timer); // Clear the timer on component unmount
  }, [showProgress]);

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate fetching data from an API
    setTimeout(() => {
      setLoading(false);
    }, 2000); // Simulating 2 seconds of loading time
  }, []); // Empty dependency array ensures this effect runs only once after initial render

  return (
    <>
      <Helmet>
        <title> Alert Management | SmartShield </title>
      </Helmet>

      <Container>
        {SearchAndTittle()}
        <Grid container direction={'row'}>
          <Grid item xs={12} container direction={'row'}>
            <Tabs value={index} onChange={handleChange} aria-label="basic tabs example">
              <Tab label="Open" {...a11yProps(0)} />
              <Tab label="In Progress" {...a11yProps(1)} />
              <Tab label="Pending Approval" {...a11yProps(2)} />
              <Tab label="Pending Rollback" {...a11yProps(3)} />
              <Tab label="Closed" {...a11yProps(4)} />
            </Tabs>
          </Grid>
          <Grid item xs={12}>
            {' '}
            <Scrollbar>
              <TableContainer sx={{ minWidth: 800, borderRadius: 2, border: '1px solid #e0e0e0' }}>
                <Table>
                  <TableHead>
                    <TableRow className="custom-table-row">
                      <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                        {t('Nomor.1')}
                      </StyledTableCell>
                      <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                        {t('AlertId.1')}
                      </StyledTableCell>
                      <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                        {t('FileId.1')}
                      </StyledTableCell>
                      <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                        {t('Dataset.1')}
                      </StyledTableCell>
                      <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                        {t('NumberOf.1')}
                      </StyledTableCell>
                      <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                        {t('DateTime.1')}
                        <Dropdown
                          menu={{
                            items,
                            onClick,
                            selectable: true,
                          }}
                        >
                          <a onClick={(e) => e.target.value}>
                            <Space>
                              <DownOutlined />
                            </Space>
                          </a>
                        </Dropdown>
                      </StyledTableCell>
                      <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>Status</StyledTableCell>
                      <StyledTableCell style={{ backgroundColor: '#E2F5FC', color: '#0E7496' }}>
                        {t('Aksi.1')}
                      </StyledTableCell>
                    </TableRow>
                  </TableHead>
                  {loading ? (
                    <TableBody>
                      <TableRow>
                        <TableCell colSpan={12} style={{ textAlign: 'center' }}>
                          <CircularProgress />
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  ) : data?.length > 0 ? (
                    <TableBody>
                      {data?.map((index, row, dataObj) => {
                        const date = new Date(index.createdAt);
                        const formattedDate = date
                          .toLocaleString('id-ID', {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                            hour12: false,
                          })
                          .replace(/\//g, '-');

                        var totalChanges = (index.authorizedCount || 0) + (index.unauthorizedCount || 0);

                        var json = JSON.stringify({
                          id: index.id,
                          recordId: index.recordId,
                          dataSet: index.dataSet,
                          totalChanges: totalChanges,
                          folder: index.folder,
                          status: index.status,
                          createdAt: formattedDate,
                          status: index.status,
                          closedStatus: index.closedStatus,
                          number: totalChanges,
                          total: {
                            authorized: index.authorizedCount || 0,
                            unauthorized: index.unauthorizedCount || 0,
                          },
                        });
                        var encodedJson = btoa(json);

                        return (
                          <TableRow hover key={row}>
                            <TableCell component="th" scope="row" alignItems="center">
                              {rowNumber + row}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="none"
                              style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                            >
                              {index.id.split('-').pop()}
                            </TableCell>

                            <TableCell
                              component="th"
                              scope="row"
                              padding="none"
                              style={{ maxWidth: '300px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                            >
                              {index.recordId}
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="none"
                              style={{ maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                            >
                              <Typography variant="body2" sx={{ paddingLeft: 2 }}>
                                {index.dataSet}
                              </Typography>
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="none"
                              style={{ maxWidth: '100px', overflow: 'center', textOverflow: 'ellipsis' }}
                            >
                              <Typography variant="body2" sx={{ fontWeight: 600, paddingLeft: 2 }}>
                                {totalChanges}
                              </Typography>
                            </TableCell>
                            <TableCell
                              component="th"
                              scope="row"
                              padding="none"
                              style={{ maxWidth: '100px', overflow: 'hidden', textOverflow: 'ellipsis' }}
                            >
                              {formattedDate}
                            </TableCell>
                            <TableCell component="th" scope="row" padding="none">
                              <span
                                style={{
                                  backgroundColor:
                                    index.status.toLowerCase() === 'open'
                                      ? theme.palette.error.main
                                      : index.status.toLowerCase() === 'process' ||
                                        index.status.toLowerCase() === 'inprogress'
                                      ? theme.palette.warning.main
                                      : index.status.toLowerCase() === 'pendingapproval'
                                      ? theme.palette.info.main
                                      : index.status.toLowerCase() === 'pendingrollback'
                                      ? theme.palette.primary.main
                                      : 'green',
                                  fontSize: 15,
                                  marginLeft: 20,
                                  color: 'white',
                                  borderRadius: 10,
                                  display: 'inline-flex',
                                  alignItems: 'center',
                                  justifyContent: 'center',
                                  width: 150,
                                }}
                              >
                                {index.status === 'Process'
                                  ? 'In Progress'
                                  : index.status === 'inProgress'
                                  ? 'In Progress'
                                  : index.status === 'pendingApproval'
                                  ? 'Pending Approval'
                                  : index.status === 'pendingRollback'
                                  ? 'Pending Rollback'
                                  : index.status === 'open'
                                  ? 'Open'
                                  : index.status === 'closed'
                                  ? 'Closed'
                                  : index.status}
                              </span>
                            </TableCell>

                            <TableCell>
                              <div
                                onClick={(event) => {
                                  event.preventDefault();
                                  if (index.status === 'open') {
                                    fetchInfoTicket(
                                      window.REACT_APP_API_PURE + 'ticket/check?alert_id=' + index.id,
                                      event,
                                      index.id
                                    );
                                    // console.log(ticketResult);
                                    // console.log('awdawda');
                                    // event.preventDefault();
                                    // if (!fetchResult) {

                                    // }
                                  }
                                }}
                              >
                                <Link
                                  to={{
                                    pathname: `/dashboard/alert/detail-alert`,
                                    search: `?id=${encodedJson}`,
                                  }}
                                  style={{
                                    textDecoration: 'none',
                                    borderRadius: '20px',
                                    border: '1px solid #12A2CE',
                                    padding: '6px 16px',
                                    color: '#12A2CE',
                                    display: 'inline-block',
                                    textAlign: 'center',
                                    cursor: 'pointer',
                                  }}
                                >
                                  {t('Detail.1')}
                                </Link>
                              </div>
                            </TableCell>
                          </TableRow>
                        );
                      })}
                      {/* {emptyRows > 0 && (
                      <TableRow style={{ height: 53 * emptyRows }}>
                        <TableCell colSpan={6} />
                      </TableRow>
                    )} */}
                    </TableBody>
                  ) : (
                    <TableRow>
                      <TableCell colSpan={12} style={{ textAlign: 'center', alignContent: 'center' }}>
                        <Empty />
                      </TableCell>
                    </TableRow>
                  )}
                </Table>
              </TableContainer>
            </Scrollbar>
          </Grid>
        </Grid>
        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={total}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Container>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleCloseMenu}
        anchorOrigin={{ vertical: 'top', horizontal: 'left' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{
          sx: {
            p: 1,
            width: 140,
            '& .MuiMenuItem-root': {
              px: 1,
              typography: 'body2',
              borderRadius: 0.75,
            },
          },
        }}
      >
        <MenuItem onClick={handleClicker}>
          <Iconify icon={'eva:edit-fill'} sx={{ mr: 2 }} />
          Process
        </MenuItem>
      </Popover>
    </>
  );
}
